import { render, staticRenderFns } from "./informDetails.vue?vue&type=template&id=47456979&scoped=true&"
import script from "./informDetails.vue?vue&type=script&lang=js&"
export * from "./informDetails.vue?vue&type=script&lang=js&"
import style0 from "./informDetails.vue?vue&type=style&index=0&id=47456979&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47456979",
  null
  
)

export default component.exports